import Vue from 'vue';
import Vuex from 'vuex';
import { Action, createVuexStore, Mutation, State } from 'vuex-simple';
import { Api } from "./api";
import { DisplayedTextTypes, apiResponse } from "./types";

Vue.use(Vuex);

export interface RootState {
    loading: boolean;
    threshold: number;
    matchResult: apiResponse | null;
    displayedTextType: DisplayedTextTypes;
}

export class Store {
    @State()
    state: RootState;
    constructor(state: RootState) {
        this.state = state;
    }

    @Action()
    dispatchMatchForTrademark(payload: { tmid: string, country: string, language: string, standard: string, gs_class: string , confToTriggerFuzzy:string}) {
        this.setLoading(true);
        Api.matchForTrademark(payload.tmid, payload.country, payload.language, payload.standard, payload.gs_class, payload.confToTriggerFuzzy)
            .then(x => {
                this.setMatchResult(x);
                this.setLoading(false);
            })
    }

    @Action()
    dispatchMatchForFreetext(payload: { text: string, country: string, language: string, standard: string, gs_class: string, confToTriggerFuzzy:string }) {
        this.setLoading(true);
        Api.matchForFreetext(payload.text, payload.country, payload.language, payload.standard, payload.gs_class, payload.confToTriggerFuzzy)
            .then(x => {
                this.setMatchResult(x);
                this.setLoading(false);
            })
    }

    @Mutation()
    setLoading(loading: boolean) {
        this.state.loading = loading;
    }

    @Mutation()
    setMatchResult(x: apiResponse) {
        this.state.matchResult = x;
    }

    @Mutation()
    displayAllTextTypes() {
        this.state.displayedTextType = {
            freetext: true,
            picklist: true
        }
    }
    @Mutation()
    updateThreshold(threshold: number) {
        console.log(threshold);
        this.state.threshold = threshold;
    }

    @Mutation()
    toggleDisplayTextType(texttype: string) {
        if (texttype === 'freetext') {
            this.state.displayedTextType.freetext = !this.state.displayedTextType.freetext;
        } else if (texttype === 'picklist') {
            this.state.displayedTextType.picklist = !this.state.displayedTextType.picklist;
        }
    }
}

const instance = new Store({
    threshold: 75,
    loading: false,
    matchResult: null,
    displayedTextType: {
        freetext: true,
        picklist: true
    }
});

export const vuexStore = createVuexStore<Store>(instance, {
    strict: true,
});

export default instance;
